import type { ReactNode } from "react";

type WorkspaceDetailsProps = {
  header?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
};

export function WorkspaceDetails({
  header,
  children,
  actions,
}: WorkspaceDetailsProps) {
  return (
    <div className="flex h-full min-h-[42rem] flex-col">
      {header && (
        <header className="border-b border-slate-200 px-6 py-5 lg:px-8">
          {header}
        </header>
      )}

      <div className="min-h-0 flex-1 overflow-y-auto px-6 py-6 lg:px-8">
        {children}
      </div>

      {actions && (
        <footer className="border-t border-slate-200 bg-slate-50 px-6 py-4 lg:px-8">
          {actions}
        </footer>
      )}
    </div>
  );
}